import { rem } from "polished";
import styled from "styled-components";

import { color } from "emoreg/const";

import { InputMessageVariant } from "./input-message";

const getColorByVariant = (variant: InputMessageVariant) => {
  switch (variant) {
    case "error":
      return color.red.base;
    case "warning":
      return color.orange.base;
    case "helper":
      return color.grey.dark;
    default:
      return color.grey.dark;
  }
};

export const Content = styled.p<{ variant: InputMessageVariant }>(({ variant }) => ({
  display: "inline",
  color: getColorByVariant(variant),
  fontSize: rem(12),
  lineHeight: 1.5,
  // FIXME: correct an unknown style applied over all p
  marginBottom: 0,
}));

Content.baseName = "InputMessageContent";

export const InputMessageStyle = Content;
